import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    addUsageEventType : [],
    loading : false,
    error : null,
};

const addUsageEventTypeSlice = createSlice({
    name:"addUsageEventType",
    initialState,
    reducers: {
        fetchAddUsageEventTypeSuccess: (state,action) => {
            state.loading = false;
            state.addUsageEventType = action.payload;
        },
        fetchAddUsageEventTypeFailure: (state,action) => {
            state.loading = false;
            state.error = action.payload
        }
    },
})

export const {
    fetchAddUsageEventTypeSuccess,
    fetchAddUsageEventTypeFailure
} = addUsageEventTypeSlice.actions

export default addUsageEventTypeSlice.reducer